import { Fragment, useContext, useEffect, useState } from "react"; // , useEffect
import { Route, Routes, Navigate, Link, useNavigate } from "react-router-dom"; // , useNavigate
import Admin from "./pages/Admin";
import Home from "./pages/Home";
import Users from "./pages/Users";
import NotFound from "./pages/NotFound";
import "./App.css";
import Login from "./components/Login";
import Button from "./components/UI/Button";
//import Navigation from "./components/Navigation";
import AuthContext from "./store/auth-context";

function App() {
  const AuthCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const [initieel, setInitieel] = useState(true);
/*
  useEffect(() => {
    //if (ctx.isLoggedIn) {
    navigate(ctx.actueleUrl);
    //}
  }, [navigate, ctx.actueleUrl]);
*/
  console.log("isLoggedIn: " + AuthCtx.isLoggedIn);
  console.log("actueleUrl: " + AuthCtx.actueleUrl);

  const redirectpath = !AuthCtx.isLoggedIn ? "/login" : "/home";
  console.log("redirectpath: " + redirectpath);

  const LinkHandler = () => {
    setInitieel(false);
  };

  useEffect(() => {
    if (initieel) {
      navigate(redirectpath);
    }
  }, [navigate, redirectpath, initieel]);

  return (
    <Fragment>
      <ul className="ulnav">
        {AuthCtx.isLoggedIn && (
          <li>
            <Link exact="true" to="/" onClick={LinkHandler}>
              Home
            </Link>
          </li>
        )}
        {!AuthCtx.isLoggedIn && (
          <li>
            <Link to="/login" onClick={LinkHandler}>
              Login
            </Link>
          </li>
        )}
        {AuthCtx.isLoggedIn && (
          <li>
            <Link to="/admin" onClick={LinkHandler}>
              Admin
            </Link>
          </li>
        )}
        {AuthCtx.isLoggedIn && (
          <li>
            <Link to="/users" onClick={LinkHandler}>
              Users
            </Link>
          </li>
        )}
        {AuthCtx.isLoggedIn && (
          <li>
            <Button onClick={AuthCtx.onLogout}>Logout</Button>
          </li>
        )}
      </ul>
      <div className="content">
        <Routes>
          <Route path="/" element={<Navigate replace to={redirectpath} />} />
          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/users" element={<Users />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </Fragment>
  );
}

export default App;